/* RESPONSIBLE TEAM: team-omni */
import Model, { attr } from '@ember-data/model';

export default class SlackIntegrationModel extends Model {
  @attr('string') declare slack_team_name: string;
  @attr('boolean') declare stale: boolean;
}
